module.exports = __webpack_public_path__ + "img/google.80241bd8.svg";